import { ExperimentsBag } from '@wix/wix-experiments';
import { IAppContext } from '../client';

export const initWixRecorder = (
  appParams: IAppContext,
  experiments: ExperimentsBag,
): void => {
  const wixRecorder: WixRecorder = window.wixRecorder;
  if (wixRecorder) {
    wixRecorder.addLabel('unknown-charge-app');
    wixRecorder.withExperiments(experiments);
    Object.entries(appParams).forEach(([key, value]) => {
      if (typeof value === 'string') {
        wixRecorder.addCustomAttribute(key, value);
      }
    });
  }
};
